import { STORE_LIST_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import {  StoreType } from "core/models/Store";

const intialState: {
  stores: StoreType[];
  count: number;
  currentPage: number;
  isLoading: boolean;
} = {
  stores: [],
  isLoading: false,
  count: 0,
  currentPage: 0,
};

interface ActionType extends Action {
  payload: {
    stores: StoreType[];
    count: number;
    currentPage: number;
  };
}

export default function storeListReducer(
  state = intialState,
  action: ActionType
) {
  switch (action.type) {
    case STORE_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true };

    case STORE_LIST_ACTION.SUCCESS:
      const { stores, count, currentPage } = action.payload;
      return { ...state, stores, count, currentPage, isLoading: false };

    case STORE_LIST_ACTION.FAILURE:
      return { ...state, ...intialState };

    default:
      return state;
  }
}
